import React from 'react';
import { useScrollAnimation } from "../../hooks/useScrollAnimation";

export const Partners = (props) => {
    const [partnersRef, isPartnersVisible] = useScrollAnimation({ threshold: 0.2 });

    return (
        <div className="p-4 sm:px-6 lg:px-8 py-4">
            <div
                ref={partnersRef}
                className={`bg-white rounded-[20px] p-4 sm:px-6 lg:p-8 shadow-sm mt-4 transition-all duration-1000 ease-out transform ${isPartnersVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
                    }`}
            >
                <div className="max-w-5xl mx-auto">
                    <div className="text-center mb-6">
                        <h1 className="text-2xl lg:text-3xl font-bold text-[#333] mb-4 font-nunito">
                            Who we're working with
                        </h1>
                    </div>
                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
                        <div className="bg-white rounded-xl p-2 h-full transition-all duration-1000 ease-out transform">
                            <img src="img/partner-logos/calseed.jpeg" alt="calseed" className="w-full h-auto rounded-lg" />
                        </div>
                        <div className="bg-white rounded-xl p-2 h-full transition-all duration-1000 ease-out transform">
                            <img src="img/partner-logos/nyserda.jpg" alt="nyserda" className="w-full h-auto rounded-lg" />
                        </div>
                        <div className="bg-white rounded-xl p-2 h-full transition-all duration-1000 ease-out transform">
                            <img src="img/partner-logos/scaqmd.jpg" alt="scaqmd" className="w-full h-auto rounded-lg" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}